import React, { useState } from "react";
import { Props } from ".../../../types/field";
import { Button, Col, Row, Typography } from "antd";
import PlatformTableComponent from "../../../../components/platformTableComponent/platformTableComponent";
import { AccessLevel, RowLevelAction } from "../../../../types/types";
import { getLoggedInUserModuleAccess } from "../../../../utils/utils";
import ViewMultipleRecord from "../../../../components/viewMultipleRecord/viewMultipleRecord";
import { reconciliationApis } from "../../../../utils/ApiURLs";
import CustomIcon from "../../../../components/icons/CustomIcon";

interface Section {
  blueprintEndpoint: string;
  urlParams: Map<string, string>;
  title: string;
}
const { Text } = Typography;

const Reconciliation: React.FC<Props> = () => {
  const [sections, setSections] = useState<Section[]>([]);
  const [platformRecord, setPlatformRecord] = useState<any>();

  const [platformRecordMappings, setPlatformRecordMappings] =
    useState<any>(undefined);
  const [bankStatementMappings, setBankStatementMappings] =
    useState<any>(undefined);
  const [bankStatementRecord, setBankStatementRecord] = useState<any>();
  const [openAction, setOpenAction] = useState(false);
  let loggedInUserAccess: AccessLevel =
    getLoggedInUserModuleAccess("reconciliation");

  const [platformAction] = useState<RowLevelAction>(
    "VIEW" as RowLevelAction
  );


  const recordMappings = (tableMappings: any, record: any): Map<string, string> => {
    let rowValueMappings = new Map<string, string>();

    Object.keys(tableMappings).map(function (key, rowField) {
      rowValueMappings.set(key, record[tableMappings[key]]);
    });
    return rowValueMappings;
  };

  const handleRowSelectionOnPlatformDataTable = (data: any, mappings: any) => {
    setPlatformRecord(data);
    setPlatformRecordMappings(mappings);
  };

  const handleRowSelectionOnBankStatementDataTable = (
    data: any,
    mappings: any
  ) => {
    setBankStatementRecord(data);
    setBankStatementMappings(mappings);
  };



  const [open, setOpen] = useState(false);

  const showModal = () => {
    if (!platformRecord || !bankStatementRecord) {
      alert("Select record from both table for Manual Reconciliation");
    } else {
      setSections([
        {
          blueprintEndpoint: reconciliationApis.manualReconciliationPlatformRecordEdit,
          urlParams: recordMappings(platformRecordMappings, platformRecord),
          title: "Platform Record",
        },
        {
          blueprintEndpoint: reconciliationApis.manualReconciliationBankStatementEdit,
          urlParams: recordMappings(bankStatementMappings, bankStatementRecord),
          title: "Bank Statement Record",
        },
      ]);

      setOpen(true);
      setOpenAction(true);
    }
  };

  return (
    <div>
      <div className="ml-2 justify-content-between mb-2">
        <div>
          <Text className="text-primary font-medium text-2xl">{"Reconciliation"}</Text>
        </div>


        <div>
          <Button  onClick={showModal} className="mr-2"> <CustomIcon height="18px" width="18px" name="manualReconcile" className="mr-2"></CustomIcon> Manual Reconciliation</Button>
          <Button  className="mr-2"> <CustomIcon height="18px" width="18px" name="autoReconcile" className="mr-2" ></CustomIcon> Auto Reconcile</Button>
        </div>

      </div>

      {openAction && (
        <>
          <ViewMultipleRecord
            open={openAction}
            sections={sections}
            isCreateFlow={false}
            isRelatedInfo={false}
            setOpen={(val: any) => setOpenAction(val)}
            title={"Manual Reconciliation"}
            userAccessLevel={loggedInUserAccess}
            platformAction={platformAction}
            customerNames={[]}
            refreshTable={() => { }}
            allowEdits={true}
            moduleCode={"reconciliation"}
          />
        </>
      )}
      <Row gutter={4}>
        <Col span={12} sm={24} lg={12}>
          <PlatformTableComponent
            bluePrintApi={reconciliationApis.reconciliationDataTable}
            searchApi={reconciliationApis.reconciliationSearchFilter}
            title="Platform"
            moduleCode={"reconciliation"}
            handleRowSelectionCallback={handleRowSelectionOnPlatformDataTable}
            showSelectAllAction={false}
            showResetAction={false}
            autoReconRowSelectionEnabled={true}
          />
        </Col>

        <Col span={12} sm={24} lg={12}>
          <PlatformTableComponent
            bluePrintApi={reconciliationApis.bankStatementsDataTable}
            searchApi={reconciliationApis.bankStatementDataTableSearchFilter}
            title="Bank Statement"
            moduleCode={"reconciliation"}
            handleRowSelectionCallback={
              handleRowSelectionOnBankStatementDataTable
            }
            showSelectAllAction={false}
            showResetAction={false}
            autoReconRowSelectionEnabled={true}
          />
        </Col>
      </Row>

    </div>
  );
};

export default Reconciliation;
